/**
 * Self-Service Calculator
 *
 * Contact: dap@visana.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type Status = 'READY' | 'IN_PROGRESS' | 'DEFERRED';

export const Status = {
    Ready: 'READY' as Status,
    InProgress: 'IN_PROGRESS' as Status,
    Deferred: 'DEFERRED' as Status
};

